const Delete = async (url,clientId) => {
    try {
        const response = await fetch(url, {
            method: 'DELETE', // Change method to DELETE
            headers: {
                'Content-Type': 'application/json',
                'x-platform': 'true',
                'clientId': clientId,
                'idToken': localStorage.getItem('user'),
            },
        });

        if (response.status === 401) {
            localStorage.removeItem('user');
            window.location.href = '/unauthorized';
        }

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data; // Return the response data
    } catch (error) {
        console.error('Error during DELETE request:', error);
        throw error; // Rethrow the error for the caller to handle
    }
};

export default Delete;